import { REDUCER_KEY_PROJECT_LIST, REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';

const getRsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);

export const getProjectsListData = (state) => getRsState(state).get(REDUCER_KEY_PROJECT_LIST);

export const getProjectsListResponse = (state) => getProjectsListData(state).response || {};

export const getProjectsTotalElements = (state) => getProjectsListResponse(state).totalElements || 0;

export const getProjectListLoading = (state) => getProjectsListData(state).isLoading;

export const getProjectToEdit = (state) => getProjectsListData(state).projectToEdit;

export const getCreatedProject = (state) => getProjectsListData(state).createdProject;

export const getImportedProjects = (state) => getProjectsListData(state).importedProjects;

export const getLastViewedProjectPosition = (state) => getProjectsListData(state).lastViewedProjectPosition;

export const getProjects = (state) => {
  const response = getProjectsListResponse(state);
  return response && response.content;
};
